import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';

// custome services
import { GlobleService } from 'src/app/core/services/globle.service';
import { AlertService } from 'src/app/core/services/alert/alert.service';

// layouts
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';


@Injectable({
    providedIn: 'root'
})
export class DepositIsPaidGuard implements CanActivate {

    constructor(
        private router: Router,
        private G: GlobleService,
        private Alert: AlertService,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        // ES6 Destructuring & Nesting & rename
        const { 
            depositPaidUser: {id:  PaidUserId } = { id: null },
        } = route?.data?.ads || {};        
      
        if (PaidUserId) {

            this.Alert.show({
                titleBtn: 'موافق',
                type: LAYOUTS_TYPE.alertFailure,
                callback: () => this.Alert.hide(),
                msg: 'التعديل على هذا عقار اصبح غير ممكن بسبب دفع عربون',
            })

            if (!this.router.url.includes('view-realty-advertisement')) this.G.navigate(['/'])

            //
            return false;
        }

        return true

    }

  
}
